export default "__VITE_ASSET__Cw7sQveW__"